import './NewsSlide.css';
import { useEffect, useState } from 'react';
import { Box, Grid, List, ThemeProvider, Typography } from '@mui/material';
import ArticleCard from '../../ArticleCard/ArticleCard';
import { fetchArticles } from '../../../backend/articles';
import {Article} from '../../../../data_types';
import theme from '../../theme';

const NewsSlide = () => {
    const [articlesPerRow, setArticlesPerRow] = useState<number>(4);
    const [articles, setArticles] = useState<Article[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadArticles = async () => {
            try {
                const data = await fetchArticles();
                if (data.articles && data.articlesPerRow) {
                    setArticles(data.articles);
                    setArticlesPerRow(data.articlesPerRow); // Update state based on fetched data
                    document.documentElement.style.setProperty('--articles-per-row', data.articlesPerRow.toString());
                } else {
                    setError('No article data available');
                }
            } catch (error) {
                setError('Failed to fetch articles');
                console.error(error);
            }
        };
        loadArticles();
    }, []);

    const groupArticles = (articles: Article[]): Article[][] => {
        const groupedArticles: Article[][] = [];
        for (let i = 0; i < articles.length; i += articlesPerRow) {
            // Use slice to get up to the next four items and push that as a new group
            groupedArticles.push(articles.slice(i, i + articlesPerRow));
        }
        return groupedArticles;
    }

    return (
        <Box className='slide' id='articles_slide'>
            <Grid className='slide_container' id='articles_slide_container' justifyContent={'center'}>
                <Grid item className='slide_content' id='slide-title'>
                    Articles
                </Grid>
                <Box className="grid-container" id="article-grid-container">
                    {error ? (
                        <Typography variant="h6" color="error" textAlign="center">
                            {error} {/* Displaying the error message */}
                        </Typography>
                    ) : (
                        groupArticles(articles).map((group, index) => (
                            <List key={index} className='component_container' disablePadding={true}>
                                {group.map(article => (
                                    <ThemeProvider theme={theme}>
                                        <ArticleCard key={article.displayId} id={String(article.displayId)} displayId={article.displayId} articleTitle={article.articleTitle} imageUrl={article.imageUrl} articleDescription={article.articleDescription} published={article.published} useDefaultImage={article.useDefaultImage} />
                                    </ThemeProvider>
                                ))}
                            </List>
                        ))
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default NewsSlide;
